import PropTypes from 'prop-types';
import { BsPencil } from 'react-icons/bs';

import { collectionActionShape } from './collectionItemShape';

export const getRenameAction = (item, onRenameStart) =>
	item.onRename ? { key: 'rename', icon: BsPencil, label: 'Umbenennen', onClick: onRenameStart } : null;

const CollectionItemActions = ({ actions }) => {
	const visibleActions = actions.filter(Boolean);
	if (visibleActions.length === 0) return null;

	return (
		<div className="flex flex-shrink-0 items-center gap-1">
			{visibleActions.map(({ key, icon: Icon, label, onClick, danger, disabled }) => (
				<button
					key={key}
					type="button"
					title={label}
					aria-label={label}
					disabled={disabled}
					onClick={(e) => {
						e.stopPropagation();
						onClick();
					}}
					className={`grid h-8 w-8 place-items-center rounded-control text-primary-500 transition-colors disabled:opacity-40 ${
						danger ? 'hover:bg-warning-200 hover:text-warning-700' : 'hover:bg-primary-200'
					}`}
				>
					<Icon className="h-4 w-4" />
				</button>
			))}
		</div>
	);
};

CollectionItemActions.propTypes = {
	actions: PropTypes.arrayOf(collectionActionShape).isRequired,
};

export default CollectionItemActions;
